<template>
    <ul class="studentList">
        <li
         v-for="(item, index) in users"
         :key="index">
            <img src="@/assets/tic/qq/5.gif" alt="">
            <span>{{ item.name }}</span>
        </li>
    </ul>
</template>
<script>
export default {
    props: ['userList'],
    computed: {
        users() {
            return this.userList;
        },
    }
}
</script>
<style scoped>
.studentList {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
    width: 100%;
    height: calc(100% - 135px);
    padding: 5px;
    background-color: #F5F5F5;
    border: 1px solid var(--theme-color);
    border-radius: 3px;
    overflow-x: hidden;
    overflow-y: scroll;
}
.studentList::-webkit-scrollbar {
    width: 3px;
}
.studentList::-webkit-scrollbar-thumb {
    width: 8px;
    height: 20px;
    background: #999aaa;
    border-radius: 3px;
}
.studentList li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50%;
    height: 80px;
    padding: 5px;
    font-size: 14px;
    
}
.studentList li img {
    width: 50px;
    height: 50px;
    margin: 5px;
    border-radius: 50%;
}
</style>


// WEBPACK FOOTER //
// src/views/classroom1/components/studentList.vue